"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoggingPrefix;
(function (LoggingPrefix) {
    LoggingPrefix["Base"] = "[javascript-obfuscator]";
    LoggingPrefix["CLI"] = "[javascript-obfuscator-cli]";
})(LoggingPrefix = exports.LoggingPrefix || (exports.LoggingPrefix = {}));
